export const GET_PARENT_CINEMAS_REQUEST = 'GET_PARENT_CINEMAS_REQUEST';
export const GET_PARENT_CINEMAS_SUCCESS = 'GET_PARENT_CINEMAS_SUCCESS';
export const GET_LIST_CINEMAS_BY_SYSTEM_REQUEST = 'GET_LIST_CINEMAS_BY_SYSTEM_REQUEST';
export const GET_LIST_CINEMAS_BY_SYSTEM_SUCCESS = 'GET_LIST_CINEMAS_BY_SYSTEM_SUCCESS';
export const ADD_LIST_MOVIE_BY_PARENT_CINEMA = 'ADD_LIST_MOVIE_BY_PARENT_CINEMA';
export const GET_SHOWTIME_BY_PARENT_CINEMAS_REQUEST = 'GET_SHOWTIME_BY_PARENT_CINEMAS_REQUEST';
export const GET_SHOWTIME_BY_PARENT_CINEMAS_SUCCESS = 'GET_SHOWTIME_BY_PARENT_CINEMAS_SUCCESS';
export const ADD_LIST_MOVIE_BY_PARENT_CINEMA_ERROR = 'ADD_LIST_MOVIE_BY_PARENT_CINEMA_ERROR';
export const GET_SHOWTIME_FILM_REQUEST = 'GET_SHOWTIME_FILM_REQUEST';
export const GET_SHOWTIME_FILM_SUCCESS = 'GET_SHOWTIME_FILM_SUCCESS';
export const GET_SHOWTIME_FILM_FAILURE = 'GET_SHOWTIME_FILM_FAILURE';
export const ADD_SHOWTIME_FILM_BY_SYSTEM_SUCCESS = 'ADD_SHOWTIME_FILM_BY_SYSTEM_SUCCESS';
export const ADD_SHOWTIME_FILM_BY_SYSTEM_FAILURE = 'ADD_SHOWTIME_FILM_BY_SYSTEM_FAILURE';

